module.exports = __webpack_public_path__ + "img/Size=16, Style=light.5401cd81.svg";